import request from '@/config/axios'

export interface LiveAnchorGoodsVO {
  id?: number
  anchorUserId?: number
  nickname?: string
  avatar?: string
  spuId?: number
  spuName?: string
  picUrl?: string
  price?: number
  spuStatus?: number
  shopId?: number
  /** 端上选品仓是否可用（与 App 同口径） */
  usable?: boolean
  usableReason?: string
  sort?: number
  createTime?: string
}

export const pageAnchorGoods = (params: any) =>
  request.get({ url: '/live/anchor-goods-admin/page', params })
export const getAnchorGoods = (id: number) =>
  request.get({ url: '/live/anchor-goods-admin/get', params: { id } })
export const createAnchorGoods = (data: LiveAnchorGoodsVO) =>
  request.post({ url: '/live/anchor-goods-admin/create', data })
export const updateAnchorGoods = (data: LiveAnchorGoodsVO) =>
  request.put({ url: '/live/anchor-goods-admin/update', data })
export const deleteAnchorGoods = (id: number) =>
  request.delete({ url: '/live/anchor-goods-admin/delete', params: { id } })
